import React from 'react';
import { useTranslation } from 'react-i18next';

import type { Filter } from '../../@types/ElasticSearchResponse';
import type QueryFilter from '../../helpers/query-filter';
import type { CombinedFacet } from '../../utils/reselectors';

interface SelectFilterItemAdvancedProps {
  filter: Filter;
  facet: CombinedFacet;
  queryFilter: QueryFilter;
  index: number;
  onChange: (filter: Filter) => void;
}

const SelectFilterItemAdvanced = ({
  filter,
  facet,
  queryFilter,
  index,
  onChange,
}: SelectFilterItemAdvancedProps) => {
  const { t } = useTranslation(['search', 'validation']);
  const isIncluded = queryFilter.contains(facet.id, filter.displayName);

  return (
    <li className="filter-check-list-item" key={filter.query}>
      <div className="filter-check-list-content">
        <button
          type="button"
          className={`filter-check-list-option-single${
            filter.selected && isIncluded ? ' is-checked' : ''
          }`}
          onClick={() => onChange(filter)}
          title={
            filter.selected && isIncluded
              ? t('Remove this filter', {
                  ns: 'search',
                  name: filter.translatedDisplayName || filter.displayName,
                })
              : t('Add this filter', {
                  ns: 'search',
                  name: filter.translatedDisplayName || filter.displayName,
                })
          }
          data-testid={`filter-modal-list-item-${index}`}
        >
          <div className="filter-check-list-option-single-icon">
            <div className="filter-check-list-option-single-checkbox" />
          </div>
          <div className="filter-check-list-option-label">
            {filter.translatedDisplayName ||
              filter.displayName ||
              t('valueMissing', { ns: 'validation' })}
          </div>
        </button>
      </div>
      <div className="filter-check-list-amout">{filter.count}</div>
    </li>
  );
};

export default SelectFilterItemAdvanced;
